import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Heading,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  MediaEmbed,
  Paragraph,
  Table,
  Undo,
  Underline,
  FontSize,
  Alignment
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';


const HtmlEditor = ({ editorData, handleChangeEditor, type, value,buttonList,height,...rest }) =>{

    const handleChange = (event, editor) => {
        const content = editor.getData();
        handleChangeEditor && handleChangeEditor(content);
      };

      
  return (
    <div key={value} >
    <CKEditor
      data={editorData}
      editor={ ClassicEditor }
      config={ {
        height: height,
        toolbar: [
          'undo', 'redo', '|',
          'heading', '|', 'bold', 'underline',
          //'italic',
          'fontSize', '|',
          //'link', 'insertTable', 'mediaEmbed', '|',
          'bulletedList', 'numberedList', 'indent', 'outdent', 'alignment', 
        ],
        plugins: [
          Bold,
          Essentials,
          Heading,
          Indent,
          IndentBlock,
         // Italic,
         // Link,
          List,
         // MediaEmbed,
          Paragraph,
         // Table,
          Undo,
          Underline,
          FontSize,
          Alignment,
        ],
        heading: {
            options: [
              { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
              { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
              { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
              { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
              { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
              { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
              { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
            ]
          },
          fontSize: {
            options: [
              'default',
              8, 9, 10, 11, 12, 14, 16, 18, 20
            ],
            supportAllValues: false  
          }

      } }
     
     // setContents={editorData}
      onChange={handleChange}
      {...rest}
    />
     <style>
        {`
          .ck-editor__editable_inline {
            min-height: 270px;
            ${height ? `height: ${height}px;` : ''}
          }
        `}
      </style>
    </div> 
  );
}
export default HtmlEditor;
